module.exports = __webpack_public_path__ + "media/roomBgm.7f5cd203.mp3";